// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__rN7_K","fullWidth":"Content_fullWidth__auz6N","withSpacing":"Content_withSpacing__VKDzc","row":"Content_row__Yji5l","column":"Content_column__XQtcf"};